import { ADD_OPEN_SUBMENU, CLEAR_OPENDED_SUBMENU } from '../mutation-types'

// 该模块的初始状态
const state = {
  list: []
}

// 相关的 mutations
const mutations = {
  [ADD_OPEN_SUBMENU] (state, name) {
    let hasThisName = false
    let isEmpty = false
    if (name.length === 0) {
      isEmpty = true
    }
    if (state.list.indexOf(name) > -1) {
      hasThisName = true
    }
    if (!hasThisName && !isEmpty) {
      state.list.push(name)
    }
  },
  [CLEAR_OPENDED_SUBMENU] (state) {
    state.list.length = 0
  }
}

export default {
  state,
  mutations
}
